export default "__VITE_ASSET__rcyqVnfM__"